/** Shared Endurava design tokens — keep in sync with index.css and marketing site.css */

export const BRAND = {
  productName: "Endurava",
  companyName: "Apex Fitness Analytics",
};

export const LAYOUT = {
  appVersion: "0.2",
  contentMaxWidth: "1600px",
};

export const TOKENS = {
  brand: {
    primary: "#31B978",
    primaryHover: "#279B64",
    primaryDark: "#1D7A50",
    primarySoft: "#E4F6EC",
  },
  dark: {
    background: "#090B0E",
    surface1: "#13181E",
    surface2: "#1A2027",
    surface3: "#232A32",
    border: "#2C343D",
    textPrimary: "#F5F7F8",
    textSecondary: "#A8B3BC",
    textMuted: "#7B8690",
  },
  light: {
    background: "#E8ECF1",
    surface1: "#FFFFFF",
    surface2: "#F3F5F8",
    surface3: "#E4E9EF",
    border: "#C5CDD6",
    textPrimary: "#12181E",
    textSecondary: "#4A5560",
    textMuted: "#52606C",
  },
  analytics: {
    green: "#31B978",
    blue: "#2F8EEA",
    amber: "#D99A2B",
    red: "#D85B5B",
    purple: "#8269C8",
    grey: "#7F8A93",
    teal: "#2AA8A0",
  },
};

export const METRIC_COLORS = {
  power: TOKENS.analytics.amber,
  normalizedPower: TOKENS.analytics.amber,
  tss: TOKENS.analytics.purple,
  hr: TOKENS.analytics.red,
  cadence: TOKENS.analytics.teal,
  speed: TOKENS.analytics.blue,
  distance: TOKENS.analytics.blue,
  pace: TOKENS.analytics.blue,
  duration: TOKENS.analytics.purple,
  calories: TOKENS.analytics.amber,
  elevation: TOKENS.analytics.green,
  temperature: TOKENS.analytics.amber,
  strava: "#FC5200",
  missing: TOKENS.analytics.grey,
  brand: TOKENS.analytics.green,
  neutral: TOKENS.analytics.grey,
};

/** CSS-variable metric accents for theme-aware UI (charts keep METRIC_COLORS hex). */
export const METRIC_VARS = {
  power: "var(--metric-power)",
  hr: "var(--metric-hr)",
  cadence: "var(--metric-cadence)",
  speed: "var(--metric-speed)",
  distance: "var(--metric-distance)",
  pace: "var(--metric-pace)",
  duration: "var(--metric-duration)",
  calories: "var(--metric-calories)",
  elevation: "var(--metric-elevation)",
  brand: "var(--metric-brand)",
  neutral: "var(--metric-neutral)",
};

export const CHART = {
  grid: "var(--app-border)",
  axis: "var(--app-border)",
  tick: "var(--app-text-muted)",
  tooltipBg: "var(--app-background)",
  tooltipBorder: "var(--app-border)",
  dotStroke: "var(--app-surface)",
  cursorFill: "var(--app-chart-cursor)",
  hoverLine: "var(--app-text-primary)",
};

export const ZONE_COLORS = {
  z1: TOKENS.analytics.blue,
  z2: TOKENS.analytics.green,
  z3: TOKENS.analytics.amber,
  z4: TOKENS.analytics.red,
  z5: "#B91C1C",
};

export const TRAINING_LOAD_SERIES = [
  { key: "acute_load", label: "Acute load", color: TOKENS.analytics.amber },
  { key: "chronic_load", label: "Chronic load", color: TOKENS.analytics.blue },
  { key: "form", label: "Form", color: TOKENS.analytics.green },
];

export const POWER_DURATION_SERIES = [
  { key: "measuredWatts", label: "Measured", color: METRIC_COLORS.power },
  { key: "smartTrainerWatts", label: "Smart trainer", color: TOKENS.analytics.purple },
  { key: "estimatedWatts", label: "Estimated", color: METRIC_COLORS.power },
  { key: "unknownWatts", label: "Unknown", color: TOKENS.analytics.grey },
];
